import React, { useCallback, useState } from "react";

import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const Register = (props) => {
  const [registerError, setRegisterError] = useState();

  const [mail, setMail] = useState();
  const [pseudo, setPseudo] = useState();
  const [password, setPassword] = useState();
  const [bio, setBio] = useState("");

  const formSignInSubmit = useCallback(
    (e) => {
      e.preventDefault();
      firebase
        .auth()
        .createUserWithEmailAndPassword(mail, password)
        .catch(function (error) {
          setRegisterError(error);
          console.log(error);
        });
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          user.updateProfile({
            displayName: pseudo,
          });
          const db = firebase.firestore();

          db.collection("users")
            .doc(user.uid)
            .set({
              pseudo: pseudo,
              id: user.uid,
              bio: bio,
              mates: [],
              posts: [],
              player_ids: [],
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
            });
        } else {
          // No user is signed in.
        }
      });
    },
    [mail, pseudo, password, bio]
  );

  const logInToggle = useCallback(() => {
    props.setRegisterTrigger(false);
    props.setLogInTrigger(true);
  }, [props]);

  return (
    <div className="absForm__content absForm__content--register ">
      <h2>S'inscrire</h2>
      {registerError && <p>{registerError.message}</p>}
      <form className="form" onSubmit={(e) => formSignInSubmit(e)}>
        <div>
          <label>Adresse mail</label>
          <input
            type="mail"
            placeholder="Adresse mail"
            onChange={(e) => setMail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Mot de passe</label>
          <input
            placeholder="Mot de passe (6 caractères min)"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Pseudo</label>
          <input
            type="text"
            placeholder="Pseudo"
            onChange={(e) => setPseudo(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Bio</label>
          <textarea
            rows="5"
            placeholder="Parle nous un peu de ta vie de gamer"
            onChange={(e) => setBio(e.target.value)}
          />
        </div>
        <button type="submit">S'inscire</button>
      </form>
      <div className="absForm__link">
        <p>
          Déjà un compte ? &nbsp;
          <button onClick={() => logInToggle()}>Se connecter</button>
        </p>
      </div>
    </div>
  );
};

export default Register;
